import React from 'react'

export default function YomaIcon({
  children,
  size = 32,
  radius = 10,
  background = '#F3EDE6',
  borderColor = '#D8C7B8'
}) {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: radius,
        background,
        border: `1px solid ${borderColor}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0
      }}
    >
      {children}
    </div>
  )
}